<template>
  <div>
    <AisMenuSelect
      :class-names="{
        'ais-MenuSelect': 'w-full',
      }"
      :limit="1000"
      :sort-by="['alpha:desc']"
      :transform-items="transformMenuItems"
      attribute="language"
      label="Language"
    >
      <template #defaultOption>
        All Languages
      </template>
      <template #default="{ items, canRefine, refine }">
        <button
          v-if="determineShouldShowButton(items)"
          class="py-2.5 px-3.5 btn btn--blue rounded-lg w-full justify-between min-w-fit text-left"
          @click="refine('')"
        >
          {{ getFacetLabel(items) }}
          <SvgIcon
            aria-hidden="true"
            icon-name="close"
            width="20"
            height="20"
          />
        </button>
        <select
          v-else
          id="language"
          aria-label="Language"
          :disabled="!canRefine"
          @change="refine($event.currentTarget?.value)"
        >
          <option value="">
            Language
          </option>
          <option
            v-for="item in items"
            :key="item.value"
            :selected="item.isRefined"
            :value="item.value"
            v-text="`${item.label} (${item.count})`"
          />
        </select>
      </template>
    </AisMenuSelect>
  </div>
</template>
<script lang="ts" setup>
import { AisMenuSelect } from 'vue-instantsearch/vue3/es'
import { FacetValue } from '~/types/globals/FacetValue'
import { toTitleCase } from '~/lib/string'

const determineShouldShowButton = (items: FacetValue[]) => items.some((e: FacetValue) => e.isRefined)

const getFacetLabel = (items: FacetValue[]) => items.find((e: FacetValue) => e.isRefined)?.label || ''

const transformMenuItems = (items: FacetValue[]) => {
  return items.map((item) => {
    return {
      ...item,
      label: toTitleCase(item.label),
    }
  })
}
</script>
